export default {
    debug: true,
    soon: false,
    checkSoon: host => false,
    directives: {
        connectSrc: [
            "api.touryup.com", "cdn.touryup.com", "www.touryup.com",
            "*.elfsight.com",
            "www.google-analytics.com",
            "www.googletagmanager.com",
            "*.google.com",
            "stats.g.doubleclick.net",
            "mc.yandex.ru",
            "cdn.linkedin.oribi.io",
            "pagead2.googlesyndication.com"
        ],
        defaultSrc: [
            "cdn.touryup.com",
            "www.dropbox.com",
            "*.dl.dropboxusercontent.com",
            "bid.g.doubleclick.net",
            "tpc.googlesyndication.com",
        ],
        imgSrc: [
            "blob:", "cdn.touryup.com", "www.touryup.com",
            "*.tripadvisor.com", '*.tile.osm.org',

            "www.facebook.com", "connect.facebook.com", "connect.facebook.net",

            "googleads.g.doubleclick.net", "www.google.com", "www.google.az", 'www.google.me', 'www.google.nl',
            "*.google-analytics.com", "*.googletagmanager.com",
            "ssl.google-analytics.com", "stats.g.doubleclick.net",
            "ssl.gstatic.com", "www.gstatic.com", "*.googleadservices.com",

            "px.ads.linkedin.com", "www.linkedin.com",

            "mc.yandex.ru"
        ],
        fontSrc: [
            "data:",
            "fonts.gstatic.com",
        ],
        frameSrc: [
            "www.youtube.com",
            "drive.google.com",
            "www.dropbox.com",
            "*.dl.dropboxusercontent.com",
            'www.facebook.com',
            "bid.g.doubleclick.net", "tpc.googlesyndication.com",
            "td.doubleclick.net"
        ],
        scriptSrc: [
            "blob:",
            "tagmanager.google.com",
            "*.googletagmanager.com",
            "www.google-analytics.com", "ssl.google-analytics.com",
            "www.google-analytics.com",
            "www.googleadservices.com", "www.google.com",
            "googleads.g.doubleclick.net",
            "tpc.googlesyndication.com",
            "connect.facebook.net",
            "mc.yandex.ru",
        ],
        styleSrc: [
            "tagmanager.google.com", "fonts.googleapis.com"
        ]
    },
    urls: {
        api: 'api.touryup.com',
        cdn: 'cdn.touryup.com',
        site: 'www.touryup.com'
    },
    //robots: "index, follow",
    title: 'TourYup',
    google: {
        tagManagerId: 'GTM-M6TXC4GJ',
        siteVerificationCode: ''
    },
    facebook: {
        pixelId: ''
    },
    robots: "index, follow",
    // css: {
    //     renderNodeSass: true,
    //     debug: false
    // },
}
